import * as React from 'react';
import { PaymentProvider } from './payment_provider';
import PaypalRadioButton from './paypal_radio_button';
import PaypalProfile from './shop_paypal_profile';

interface Props {
  shopCurrency: string;
  inputName: string;
  onPaymentProviderChange(paymentProvider: PaymentProvider): void;
  errorMessages: string[];
  paypalProfileCreatedAt: string;
  paypalProfileFormPrefix: string;
  paypalAccountLink: string;
  userAttributes?: { firstName: string; lastName: string };
  selected: boolean;
}

export default function PaymentProviderPaypalOption(props: Props) {
  return (
    <div>
      <PaypalRadioButton
        inputName={props.inputName}
        checked={props.selected}
        handleChangePaymentMethod={props.onPaymentProviderChange}
        shopCurrency={props.shopCurrency}
      />
      {props.selected &&
        <PaypalProfile
          errorMessages={props.errorMessages}
          createdAt={props.paypalProfileCreatedAt}
          formPrefix={props.paypalProfileFormPrefix}
          paypalAccountLink={props.paypalAccountLink}
          userAttributes={props.userAttributes}
        />
      }
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/payment_provider_paypal_option.tsx